<template>
  <div class="pa-4">
    <portal to="app-header">
      <router-link
        to="/speakcode"
        class="ml-2"
      >
        看看代码
      </router-link>
    </portal>
    <textarea
      ref="textarea"
      v-model="text"
      class="pa-2"
      style="width: 100%;border: 1px solid lightblue;"
      rows="10"
    />
    <v-btn
      @click="hanleClick"
    >
      播放语音
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'Speak',
  data() {
    return {
      text: '说实话，我没有看过格力给我的工资条，我来格力的时候，我就说董总能不能给我一间靠近您的办公室，我要随时跟您汇报。我曾经幻想过，如果在我的职业生涯当中，有那么一段经历，可以跟在一个顶级企业家身边，我每天哪怕什么都不做，就看她怎么开会，听她讲什么，做什么，都是一件很幸福的事儿。',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.textarea.focus()
    })
  },
  methods: {
    hanleClick() {
      const speech = new SpeechSynthesisUtterance();
      speech.text = this.text;
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      // speech.lang = 'zh-CN';
      window.speechSynthesis.speak(speech);
      // this.text = '';
      // this.$refs.textarea.focus()
    }
  }
}
</script>

<style>

</style>